import { isUndefined, isNull } from "underscore";
import { DataStore } from "shared_critical/store";

export function priceToNumber(value) {
  return value.replace(/^.*\$(0)0*$|.*\$0*|,/gm, "$1");
}

export function commaDelimit(value) {
  if(!value) { return "0"; }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function isBlank(value) {
  return (isUndefined(value) || isNull(value) || value.length === 0);
}

export function formatPrice (value) {
  var abbr = value.trim().last(1).toLowerCase(),
      number = value.toNumber();
  
  switch (abbr) {
    case "k":
      return number * 1000;
    case "m":
      return number * 1000000;
    default:
      return value.toNumber();
  }
}

export const nyExp = DataStore.getData("NY_EXP");


// WEBPACK FOOTER //
// ./srp/scripts/utils/helper.js